import { render, staticRenderFns } from "./BaseInternalChartValorization.vue?vue&type=template&id=5f8c981e&scoped=true&"
import script from "./BaseInternalChartValorization.vue?vue&type=script&lang=ts&"
export * from "./BaseInternalChartValorization.vue?vue&type=script&lang=ts&"
import style0 from "./BaseInternalChartValorization.vue?vue&type=style&index=0&id=5f8c981e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8c981e",
  null
  
)

export default component.exports